// Theme colors an opened artwork can use, labelled as in Colors & Fonts
export const VIEWER_THEME_COLOR_OPTIONS = [
  { value: 'bgColor', label: 'Page background' },
  { value: 'textColor', label: 'Main text' },
  { value: 'headerColor', label: 'Header background' },
  { value: 'accentColor', label: 'Buttons' },
  { value: 'highlightColor', label: 'Accents' }
]
